import styled from 'styled-components'
import { baseTheme } from 'primsell-shared-layer/styles/theme'

import { Typography as CommonTypography } from 'primsell-shared-layer/components'

export const NFTDetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
`

export const NFTTitle = styled(CommonTypography)`
  && {
    margin-top: 24px;
    font-size: 24px;
    font-weight: 600;
    font-style: normal;
    line-height: normal;
  }
`

export const BurnFormContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 20px;
`

export const NFTDescription = styled(CommonTypography)`
  margin-top: 8px;
  color: ${baseTheme.colors.lightDark};
  font-size: 14px;
  line-height: 150%;
`

export const ExpirationDateContainer = styled.div`
  margin-top: 12px;
  width: fit-content;
  padding: 10px 12px;
  background: #d4d3d5;
  border-radius: 4px;
  opacity: 0.6;
`

export const ExpirationTypography = styled(CommonTypography)`
  color: ${baseTheme.colors.dark};
  font-size: 14px;
  line-height: 150%;
`
